import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { localGet } from '@/config/storage'
import { ElMessage } from 'element-plus'
import store from '@/store'

const routes : Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'index',
		redirect: '/consultationRecord',
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('../views/login/login.vue'),
		meta: {
			title: '登录',
			module: 'login',
			showLeftMenu: false,
			showNav: false,
		}
	},
	{
	    name: 'user',
	    path: '/user',
	    component: () => import('@/views/user/User.vue'),
	    meta: {
	        title: '用户管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'log'
	    }
	},
	{
	    name: 'consultationRecord',
	    path: '/consultationRecord',
	    component: () => import('@/views/consultationRecord/ConsultationRecord.vue'),
	    meta: {
	        title: '咨询记录',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'consultationRecord'
	    }
	},
	{
	    name: 'presetQuestion',
	    path: '/presetQuestion',
	    component: () => import('@/views/presetQuestion/PresetQuestion.vue'),
	    meta: {
	        title: '预设问题',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'presetQuestion'
	    }
	},
	{
	    name: 'productQuestionnaire',
	    path: '/productQuestionnaire',
	    component: () => import('@/views/productQuestionnaire/ProductQuestionnaire.vue'),
	    meta: {
	        title: '产品问卷',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'productQuestionnaire'
	    }
	},
	{
	    name: 'role',
	    path: '/role',
	    component: () => import('@/views/role/Role.vue'),
	    meta: {
	        title: '角色管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'role'
	    }
	},
	{
	    name: 'platform',
	    path: '/platform',
	    component: () => import('@/views/platform/Platform.vue'),
	    meta: {
	        title: '关于平台',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'platform'
	    }
	},
	{
	    name: 'process',
	    path: '/process',
	    component: () => import('@/views/process/Process.vue'),
	    meta: {
	        title: '工艺生成',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'process'
	    }
	},
	{
	    name: 'agent',
	    path: '/agent',
	    component: () => import('@/views/agent/Agent.vue'),
	    meta: {
	        title: '智能体管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'agent'
	    }
	},
	{
	    name: 'content',
	    path: '/content',
	    component: () => import('@/views/content/Content.vue'),
	    meta: {
	        title: '文案管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'content'
	    }
	},
	{
	    name: 'appletManagement',
	    path: '/appletManagement',
	    component: () => import('@/views/appletManagement/AppletManagement.vue'),
	    meta: {
	        title: '小程序管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'appletManagement'
	    }
	},
	{
	    name: 'knowledgeBase',
	    path: '/knowledgeBase',
	    component: () => import('@/views/knowledgeBase/KnowledgeBase.vue'),
	    meta: {
	        title: '知识库管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'knowledgeBase'
	    }
	},
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

router.beforeEach((to, _, next) => {
	const token = localGet('token')
	if(token){
		if (to.meta.title == '登录') {
			next('/')
		} else {
			next()
		}
	}else{
		if (to.meta.needToken) {
			ElMessage.error('请先登录')
			next('/login')
		} else {
			next()
		}
	}
})
router.afterEach(to => {
	let title = store.state?.publicOptions.platformInfo.systemName
	if(to.meta.title){
		title = String(to.meta.title)
	}
	document.title = title
})

export default router